import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import useConnectWs from "../../../hooks/useConnectWs";
import { ContractPromise } from "@polkadot/api-contract";
import metadata from "../../../contract/metadata.json";
import { showBalanceWithSpanLayout } from "../../../utils/Helpers";
import { useNavigate } from "react-router-dom";
import routes from "../../../constants/routes";

const TokenItem = (props) => {
  const { t } = useTranslation();
  const [api, setApi] = useConnectWs();
  const { account, mnemonic } = useSelector((state) => state.account);
  const [balances, setBalances] = useState(0);
  const history = useNavigate();

  useEffect(() => {
    if (account && api) {
      getDataToken();
    }
  }, [account, api]);

  const getDataToken = async () => {
    const contract = new ContractPromise(
      api,
      metadata,
      props.token.attributes.token_contract
    );
    const from = "5GrwvaEF5zXb26Fz9rcQpDWS57CtERHpNehXCPcNoHGKutQY";
    const target = account?.address;
    const callValue = await contract.query.balanceOf(
      from,
      { gasLimit: -1 },
      target
    );
    setBalances(callValue.output?.toLocaleString());
  };

  return (
    <>
      {balances > 0 ? (
        <div className="item">
          <div className="left">
            <div className="image">
              <img
                src={
                  "https://www.gravatar.com/avatar/" +
                  props.token.attributes.token_contract +
                  "?s=128&d=identicon"
                }
                alt={props.token.attributes.token_name}
                title={props.token.attributes.token_contract}
              />
            </div>
            <div className="text">
              <div className="title">{props.token.attributes.short_name}</div>
              <div
                className="content"
                dangerouslySetInnerHTML={{
                  __html: showBalanceWithSpanLayout(balances),
                }}
              ></div>
            </div>
          </div>
          <div
            className="right"
            onClick={() =>
              history(
                routes.sendToken +
                  "?symbol=" +
                  props.token.attributes.short_name +
                  "&address=" +
                  props.token.attributes.token_contract
              )
            }
          >
            <img src="/images/wallet2.svg" alt="" />
            {t("createToken.Send")}
          </div>
        </div>
      ) : (
        <></>
      )}
    </>
  );
};

export default TokenItem;
